var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top_content"},[_vm._m(0),_c('select-section')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"userinfo"}},[_c('p',[_vm._v("pluscommユーザー情報が更新されました。")])])}]

export { render, staticRenderFns }